import type { WorkspaceListItem } from "./authApi";

/**
 * Survives `WorkspaceNavSection` unmount when the mobile sidebar hides (e.g. open DM).
 * Cleared on logout / failed load so another account or error state does not reuse stale data.
 */
let sessionList: WorkspaceListItem[] | null = null;
let sessionLoadedOk = false;

export function getWorkspaceNavSessionSnapshot(): { list: WorkspaceListItem[]; hasLoaded: boolean } {
  return {
    list: sessionList ? [...sessionList] : [],
    hasLoaded: sessionLoadedOk,
  };
}

export function commitWorkspaceNavSessionCache(list: WorkspaceListItem[]): void {
  sessionList = [...list];
  sessionLoadedOk = true;
}

export function clearWorkspaceNavSessionCache(): void {
  sessionList = null;
  sessionLoadedOk = false;
}
